export default __webpack_public_path__ + "static/media/project2.08f045df.PNG";